import * as React from 'react';
import { AlertTriangle } from 'lucide-react';
import { IAlertSeverityData, IAlertSourceData } from '../analytics.types';

interface IActiveAlertsCardProps {
  alertsBySeverity: IAlertSeverityData[];
  alertsBySource: IAlertSourceData[];
  totalActiveAlerts: number;
}

const ActiveAlertsCard = ({
  alertsBySeverity,
  alertsBySource,
  totalActiveAlerts,
}: IActiveAlertsCardProps): React.JSX.Element => {
  const showEmptyState : boolean = totalActiveAlerts === 0;

  return (
    <div className="analytics-card">
      <div className="card-title">
        <AlertTriangle size={20} strokeWidth={1.5} />
        <h2>Active Alerts</h2>
        <span className="badge-total">{totalActiveAlerts}</span>
      </div>

      {showEmptyState ? (
        <div className="analytics-empty-state">
          No active alerts available for the selected period.
        </div>
      ) : (
        <>
          <div className="alert-severity-list">
            {alertsBySeverity.map((alert: IAlertSeverityData) => (
              <div key={alert.severity} className="severity-row">
                <div className="severity-label">
                  <span
                    className="severity-dot"
                    style={{ backgroundColor: alert.color }}
                  />
                  <span>{alert.severity}</span>
                </div>
                <div className="severity-bar-container">
                  <div
                    className="severity-bar"
                    style={{
                      width: `${(alert.count / totalActiveAlerts) * 100}%`,
                      backgroundColor: alert.color,
                    }}
                  />
                </div>
                <span className="severity-count">{alert.count}</span>
              </div>
            ))}
          </div>

          <div className="alert-source-section">
            <h3>By Source</h3>
            <div className="alert-source-grid">
              {alertsBySource.map((source) => (
                <div key={source.source} className="source-item">
                  <span className="source-count">{source.count}</span>
                  <span className="source-label">{source.source}</span>
                </div>
              ))}
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default ActiveAlertsCard;